/* global module */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './fontawesome.css';
import App from './App';
import {
  beginDirectGitLabSignIn,
  isCompletingDirectSignIn,
  completeGitLabSignIn,
  abandonGitLabSignIn,
} from './lib/gitlab_direct_sign_in';
import { createGitlabOAuth } from './sync_backend_clients/gitlab_sync_backend_client';
import { isRemarkableCallback, completeRemarkableSignIn } from './lib/remarkable_mcp';
import './custom-todo-colors.css';

const rootElement = document.getElementById('root');

const renderNotice = (text) => {
  rootElement.textContent = text;
  rootElement.style.padding = '1em';
};

function render() {
  // Direct sign-in links (/gitlab/org/ml) bypass the app entirely on both
  // legs of the OAuth round trip; see lib/gitlab_direct_sign_in.js.
  // The reMarkable sign-in popup returns here; it never renders the app, so a
  // second organice instance never runs next to the one that opened it.
  if (isRemarkableCallback()) {
    renderNotice('Signing in to reMarkable…');
    completeRemarkableSignIn().then(renderNotice);
  } else if (beginDirectGitLabSignIn()) {
    renderNotice('Connecting to GitLab…');
  } else if (isCompletingDirectSignIn()) {
    renderNotice('Signing in…');
    completeGitLabSignIn(createGitlabOAuth())
      .catch((e) => {
        console.error('Unhandled error while completing GitLab sign in:', e);
        return false;
      })
      .then((success) => {
        if (!success) {
          abandonGitLabSignIn();
          window.location.replace(window.location.origin + '/sign_in');
        }
      });
  } else {
    ReactDOM.render(<App />, rootElement);
  }
}

render();

// Remove Parcel error overlay for e2e testing
// See: https://github.com/parcel-bundler/parcel/issues/9738
// The overlay intercepts pointer events when running e2e tests after jest
if (typeof window !== 'undefined') {
  const removeParcelErrorOverlay = () => {
    const overlay = document.querySelector('parcel-error-overlay');
    if (overlay) {
      overlay.remove();
    }
  };

  // Remove immediately
  removeParcelErrorOverlay();

  // Watch for overlay being added
  const observer = new MutationObserver(() => {
    removeParcelErrorOverlay();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

// Enable Hot Module Replacement (full reload for ES modules)
if (module.hot) {
  module.hot.accept();
}
